<div class="barWrapper progress">
  <div class="progress-bar"  [ngClass]="{'w-100' : completed}" [ngStyle]="{'width': isActive ? storyProgressPercentage : '' }" id="progressBar"  #progressBar></div>
</div>
